import React from "react";
import Box from "../component/Box/Box";
import PropTypes from "prop-types";
import Notify from "../services/Notify";
import Loading from "../component/Loading/Loading";
import {ControlLabel, FormGroup} from "react-bootstrap";
import MapService from "./MapService";
import FormButtons from "../component/Form/FormButtons";

class MapForm extends React.Component {

  service = new MapService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.service.findById(id).then(
          data => this.setState(
              {
                loading: false,
                entity: data
              }),
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      )
    }
  }

  submitForm() {
    const existingEntity = this.state.entity && this.state.entity.id;
    const entityVersion = this.state.entity && this.state.entity.version;
    const entity = {
      id: existingEntity,
      friendlyName: this.friendlyName.value.trim(),
      description: this.description.value.trim(),
      company: {id: this.companyId},
      version: entityVersion
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.service.save(entity).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) => {
          Notify.error('Falha ao salvar entidade:', error);
          this.setState({loading: false, entity, message: null});
        }
    );
  }

  render() {
    const {loading, entity = {}, message, showCompany} = this.state;

    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>
            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input type="text" className="form-control" placeholder="Nome"
                     required
                     name="friendlyName"
                     ref={
                       friendlyName => this.friendlyName = friendlyName
                     }
                     defaultValue={entity && entity.friendlyName}/>
            </FormGroup>

            <FormGroup>
              <ControlLabel>Descrição</ControlLabel>
              <input type="text" className="form-control" placeholder="description"
                     required
                     name="description"
                     ref={
                       description => this.description = description
                     }
                     defaultValue={entity && entity.description}/>
            </FormGroup>

            <FormButtons history={this.props.history}/>
          </form>
        </Box>);

  }
}

MapForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default MapForm;



// WEBPACK FOOTER //
// ./src/map/MapForm.js